import { z } from "zod";
import { UIElementType } from "../../../AppConstants";
import { t } from "i18next";

const getServiceTypeSchema = () => {
  return z.object({
    ServiceName: z
      .string()
      .min(1, { message: "Sector name is required" })
      .describe(JSON.stringify({ elementType: UIElementType.TEXTFIELD, inputLabel: t("serviceTypeList.serviceName"), isRequired: true })),
    GrossMarginContracts: z.union([z.literal(0), z.number().positive()])
      .nullable()
      .refine(value => value === null || value >= 0, {
        message: "If entered, the number must be positive or zero",
      }).describe(
        JSON.stringify({
          inputType: "number",
          elementType: UIElementType.TEXTFIELD,
          inputLabel: t("serviceTypeList.grossMarginContracts"),
          isRequired: true,
        })
      ),
    GrossMarginJobs: z.union([z.literal(0), z.number().positive()])
      .nullable()
      .refine(value => value === null || value >= 0, {
        message: "If entered, the number must be positive or zero",
      }).describe(
        JSON.stringify({
          inputType: "number",
          elementType: UIElementType.TEXTFIELD,
          inputLabel: t("serviceTypeList.grossMarginJobs"),
          isRequired: true,
        })
      ),
  });
};

const getServiceTypeDefaultValue = (value = null) => {
  return {
    ServiceName: value ? value?.ServiceName : "",
    GrossMarginContracts: (value && value.GrossMarginContracts !== undefined && value.GrossMarginContracts !== null) ? value.GrossMarginContracts : "",
    GrossMarginJobs: (value && value.GrossMarginJobs !== undefined && value.GrossMarginJobs !== null) ? value.GrossMarginJobs : "",
  };
};

const getServiceTypeAPIPostSchema = (countryCode, businessCode) => {
  return {
    countryCode: countryCode,
    businessCode: businessCode,
    serviceType: [
      {
        ServiceTypeId: "",
        ServiceName: null,
        GrossMarginContracts: 0,
        GrossMarginJobs: 0,
        Deleted: false,
        CountryCode: countryCode,
        BusinessCode: businessCode,
      },
    ],
  };
};

const getServiceTypeAuditInfoSchema = () => {
  return {
    auditInfo: [
      {
        Location: "Service Type",
        LocationKey: "",
        Action: null,
        shortDesc: null,
        currentState: null,
        previousState: null,
      },
    ],
  };
};

export { getServiceTypeSchema, getServiceTypeDefaultValue, getServiceTypeAPIPostSchema, getServiceTypeAuditInfoSchema };
